import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { PadSplashScreenBlockConfig } from '@front-platform/content-builder';
import { padSplashScreenBlockResolveConfig } from '@front-platform/content-builder';
import { timer } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';

import { MarketplaceKeys } from '@config/keys/shop.keys';
import { UserKeys } from 'src/app/config/keys/user.keys';

import { IKiosk } from '@core/models/kiosk.model';
import { DoodUserModel } from '@store/authentication/authentication.model';

import { KioskService } from '@core/services/kiosk/kiosk.service';
import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
export interface PadSplashScreenBlockRuntimeConfig {}

export type PadSplashScreenBlockConfigInput = Partial<
  Omit<PadSplashScreenBlockConfig, keyof PadSplashScreenBlockRuntimeConfig> &
    PadSplashScreenBlockRuntimeConfig
>;
export type PadSplashScreenBlockResolvedConfig = Omit<
  PadSplashScreenBlockConfig,
  keyof PadSplashScreenBlockRuntimeConfig
> &
  Partial<PadSplashScreenBlockRuntimeConfig>;
export interface PadSplashScreenBlockContract extends ConfigComponentContract<
  PadSplashScreenBlockConfigInput,
  PadSplashScreenBlockResolvedConfig
> {}

@Component({
  selector: 'app-pad-splash-screen-block',
  templateUrl: './pad-splash-screen-block.component.html',
  standalone: false,
})
export class PadSplashScreenBlockComponent
  extends DestroyerBase
  implements OnInit, PadSplashScreenBlockContract
{
  readonly config = input<PadSplashScreenBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    PadSplashScreenBlockConfig,
    PadSplashScreenBlockRuntimeConfig
  >(padSplashScreenBlockResolveConfig, () => ({ config: this.config() }));
  userKeys = UserKeys;
  user: DoodUserModel | null = null;

  kioskInProgress = true;
  kiosk: IKiosk | undefined;
  displaySplashScreen = true;
  kioskId: string | null = null;

  constructor(
    private authSelector: AuthStoreSelector,
    private readonly kioskService: KioskService,
    private marketplaceSelector: MarketplaceStoreSelector,
  ) {
    super();
  }

  ngOnInit(): void {
    const marketplace = this.marketplaceSelector.marketplace;
    const kioskId = this.kioskService.getKioskIdFromStore();
    if (kioskId) {
      this.kioskService
        .getKiosks$(marketplace[MarketplaceKeys.Id])
        .pipe(
          tap(kiosks => {
            this.kiosk = kiosks.find(kiosk => kiosk.id === kioskId);
            if (!this.kiosk) {
              this.kioskService.saveKioskIdToStore(undefined);
            }
            this.kioskInProgress = false;
            this.shouldHideSplashScreen();
          }),
        )
        .subscribe();
    }

    this.authSelector.selectUser$
      .pipe(
        takeUntil(this._destroyerRef),
        tap(user => (this.user = user)),
        tap(() => this.shouldHideSplashScreen()),
      )
      .subscribe();
  }

  shouldHideSplashScreen(): void {
    if (this.kiosk && this.user) {
      timer(1500).subscribe(() => {
        this.displaySplashScreen = false;
      });
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(PadSplashScreenBlockComponent, { 'keyAliases': {} });
